import Input from "../../components/atoms/Input/input";
import { Field, Form } from "react-final-form";
import Button from "../../components/atoms/Button/Button";
import {
  composeValidators,
  emailValidator,
  requiredFieldValidator,
} from "../../common/Utility/validator";
import styles from "./Login.module.scss";
import { useNavigate } from "react-router-dom";
import {
  fetchEncryptionData,
  isAuthenticated,
  isMarketPlace,
  isScmAuthenticated,
  setInLocalStorage,
} from "../../common/utility";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { sendUserOTP } from "../../api/SignupAPI";
import { channelAll } from "./channelTypes";
import TwoFactorAuth from "./twoFactorAuth";
import { Paths } from "../../Routes/path";
const LoginForm = () => {
  const [otpModal, setOtpModal] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const redirectToDashBoard = () => {
    if (isMarketPlace()) {
      navigate(Paths.scmDashboard.path);
    } else navigate(Paths.internalDashboard.path);
  };

  /**
   * Send Already logged in user to dashboard
   */
  useEffect(() => {
    const body = document.querySelector("body");
    if (isAuthenticated()) {
      redirectToDashBoard();
    } else if (isScmAuthenticated()) {
      redirectToDashBoard();
    }
    if (isMarketPlace()) {
      body.style.backgroundColor = "#F4F5FF";
      body.style.fontFamily = "Nunito";
    }
    return () => {
      body.style.backgroundColor = "#FFF";
    };
    // eslint-disable-next-line
  }, []);

  //Fetch public rsa key pre login if it's not present on app load
  const preLogin = async () => {
    await fetchEncryptionData();
  };

  const postLogin = async (authorisation) => {
    try {
      const accessToken = authorisation && authorisation.accessToken;
      let permissions = undefined;
      let sessionMode = undefined;
      if (accessToken) {
        const accessTokenDecoded = jwtDecode(authorisation.accessToken);
        //  permissions = await fetchPermissions(accessToken, accessTokenDecoded);
        sessionMode = accessTokenDecoded && accessTokenDecoded.sessionMode;
      }

      if (isMarketPlace()) {
        setInLocalStorage("scm", "login", {
          ...authorisation,
          sessionMode,
          roles: permissions && permissions.attributes,
        });
      } else {
        setInLocalStorage("lco", "login", {
          ...authorisation,
          sessionMode,
          roles: permissions && permissions.attributes,
        });
      }
    } finally {
      // as a fallback always go to dashboard..
      redirectToDashBoard();
    }
  };

  const credentialsVerified = async (values) => {
    try {
      await postLogin(values);
    } catch (e) {
      // return handleLoginError(e);
    }
  };
  const generateOTP = async (values) => {
    try {
      await preLogin();
      let payload = {
        emailId: values.emailId,
        channelType: channelAll,
      };
      const loginResp = await sendUserOTP(payload);
      if (loginResp) {
        setOtpModal(true);
        setFormData(values);
        return;
      }
    } catch (e) {
      //return handleLoginError(e);
    }
  };

  return (
    <div className="loginForm">
      <div className="email-section">
        <Form
          onSubmit={generateOTP}
          render={({ handleSubmit, form, hasValidationErrors }) => (
            <form onSubmit={handleSubmit} noValidate>
              <Field
                required={true}
                label="Email Address"
                component={Input}
                name="emailId"
                key="emailId"
                validate={composeValidators([
                  requiredFieldValidator,
                  emailValidator,
                ])}
              />
              <div className="actions">
                <Button
                  variant="primary"
                  className={`${styles["loginBtn"]}`}
                  disabled={hasValidationErrors}
                  type="submit"
                  btnText="Login"
                />
              </div>
            </form>
          )}
        />
      </div>
      {!!otpModal && (
        <TwoFactorAuth
          credentialsVerified={credentialsVerified}
          emailId={formData.emailId}
          handleClose={() => {
            setOtpModal(false);
          }}
        />
      )}
    </div>
  );
};

export default LoginForm;
